// AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext();

const AuthStdProvider = ({ children }) => {
  const [isStdAuthenticated, setIsStdAuthenticated] = useState(false);

  useEffect(() => {
    const loggedInUser = localStorage.getItem("student")
    try{
      const student= JSON.parse(loggedInUser)
     if(student?.id){
        localStorage.setItem("studentId",student.id)
        setIsStdAuthenticated(true)
     }else{
        setIsStdAuthenticated(false)
     }
    }catch(e){
        setIsStdAuthenticated(false)
    }
  }, [])

  const logout = () => {
    localStorage.removeItem("student")
    localStorage.removeItem("student_token")
    localStorage.removeItem("studentId")
    localStorage.clear()
    setIsStdAuthenticated(false)
    window.location.reload(false)
  }

  return (
    <AuthContext.Provider 
      value={{ isStdAuthenticated, setIsStdAuthenticated, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

const useAuthStd = () => useContext(AuthContext);

export { AuthStdProvider, useAuthStd };
